import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";
import { moodSmileIcon } from "../../MapMarkerIcons/MapMarkerIcons";

export function UbicacionPersonalViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const apellido = record[3] as string;
    const nombre = record[4] as string;
    const fecha = record[5] as string;
    const puesto = record[6] as string;

    const icon = moodSmileIcon;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - Fecha Localización: ${fecha}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.green[6],
    }

    return markerProps;
}